export const AIR = "air";
export const CAR = "car";
export const VACATION = "vacation";
